(function () {

  // ── スライダー ──────────────────────────────
  var prevBtn    = document.getElementById('tmt-prev');
  var nextBtn    = document.getElementById('tmt-next');
  var currentEl  = document.getElementById('tmt-current');
  var current2El = document.getElementById('tmt-current2');
  var totalEl    = document.getElementById('tmt-total-display');
  var total2El   = document.getElementById('tmt-total-display2');
  var current    = 0;
  var slides     = [];
  var total      = 0;

  function isMobile() { return window.innerWidth <= 767; }

  function buildSlides() {
    slides = Array.from(document.querySelectorAll('.tmt-catalog__slide')).filter(function (s) {
      if (s.classList.contains('tmt-slide--desktop')) return !isMobile();
      if (s.classList.contains('tmt-slide--mobile'))  return isMobile();
      return true;
    });
    total = slides.length;
    if (totalEl)  totalEl.textContent  = total;
    if (total2El) total2El.textContent = total;
  }

  function applyHeight() {
    var header = document.querySelector('.tmt-catalog__header');
    var nav    = document.querySelector('.tmt-catalog__nav');
    var announcement = document.querySelector('[id*="announcement-bar"]');
    var announcementHeight = announcement ? announcement.offsetHeight : 0;
    var h = window.innerHeight
      - (header ? header.offsetHeight : 0)
      - (nav    ? nav.offsetHeight    : 0)
      - announcementHeight;
    slides.forEach(function (s) { s.style.height = h + 'px'; });
  }

  function goTo(index) {
    current = Math.max(0, Math.min(index, total - 1));

    document.querySelectorAll('.tmt-catalog__slide').forEach(function (s) {
      s.style.setProperty('display', 'none', 'important');
    });

    if (slides[current]) {
      slides[current].style.setProperty('display',
        slides[current].classList.contains('tmt-catalog__slide--products') ? 'flex' : '',
        'important'
      );
    // ── ここから追加 ──────────────────────────────
    slides[current].querySelectorAll('.tmt-catalog__product-col').forEach(function (col) {
      var thumbs  = col.querySelectorAll('.tmt-catalog__thumb');
      var mainImg = col.querySelector('.tmt-catalog__main-image');
      if (!thumbs.length || !mainImg) return;

      // サムネイルのis-activeを全リセット → 1枚目をアクティブに
      thumbs.forEach(function (t) { t.classList.remove('is-active'); });
      thumbs[0].classList.add('is-active');

      // メイン画像を1枚目のサムネイルに合わせる
      if (thumbs[0].dataset.full) mainImg.src = thumbs[0].dataset.full;

      // カラーボタンも1枚目をアクティブに
      var colorBtns = col.querySelectorAll('.tmt-catalog__color-btn');
      colorBtns.forEach(function (b) { b.classList.remove('is-active'); });
      if (colorBtns[0]) colorBtns[0].classList.add('is-active');
    });
    // ── ここまで追加 ──────────────────────────────
    }

    currentEl.textContent  = current + 1;
    current2El.textContent = current + 1;
    prevBtn.disabled = current === 0;
    nextBtn.disabled = current === total - 1;

    document.body.style.overflow = (current <= 1) ? 'hidden' : '';
  }

  prevBtn.addEventListener('click', function () { goTo(current - 1); });
  nextBtn.addEventListener('click', function () { goTo(current + 1); });

  window.addEventListener('resize', function () {
    buildSlides();
    applyHeight();
    goTo(0);
  });

  var announcementSection = document.querySelector('[id*="announcement-bar"]');
  if (announcementSection && isMobile()) {
    announcementSection.style.visibility = 'hidden';
    announcementSection.style.pointerEvents = 'none';
  }

  document.body.style.overflow = 'hidden';
  buildSlides();
  applyHeight();
  goTo(0);

  document.addEventListener('keydown', function (e) {
    if (e.key === 'ArrowRight' || e.key === 'ArrowDown') goTo(current + 1);
    if (e.key === 'ArrowLeft'  || e.key === 'ArrowUp')   goTo(current - 1);
  });

  // ── 画像プリロード ──────────────────────────
  document.querySelectorAll('.tmt-catalog__thumb').forEach(function (thumb) {
    var img = new Image(); img.src = thumb.dataset.full;
  });

  // ── サムネイルクリック ──────────────────────
  document.querySelectorAll('.tmt-catalog__thumb').forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      var col = this.closest('.tmt-catalog__product-col');
      col.querySelector('.tmt-catalog__main-image').src = this.dataset.full;
      col.querySelectorAll('.tmt-catalog__thumb').forEach(function (t) { t.classList.remove('is-active'); });
      this.classList.add('is-active');
    });
  });

  // ── カラーボタンクリック ────────────────────
  document.querySelectorAll('.tmt-catalog__color-btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var col     = this.closest('.tmt-catalog__product-col');
      var mainImg = col.querySelector('.tmt-catalog__main-image');
      var thumbs  = col.querySelectorAll('.tmt-catalog__thumb');
      col.querySelectorAll('.tmt-catalog__color-btn').forEach(function (b) { b.classList.remove('is-active'); });
      this.classList.add('is-active');
      var imgUrl = this.dataset.img;
      if (imgUrl) {
        mainImg.src = imgUrl;
        var matched = null;
        thumbs.forEach(function (t) { if (!matched && t.dataset.full === imgUrl) matched = t; });
        thumbs.forEach(function (t) { t.classList.remove('is-active'); });
        if (matched) matched.classList.add('is-active');
      }
      if (window.innerWidth <= 767) {
        setTimeout(function () {
          mainImg.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }, 160);
      }
    });
  });

  // ── カート状態 ─────────────────────────────
  var cart = [];

  function updateCartBadge() {
    var totalQty = cart.reduce(function (s, i) { return s + i.qty; }, 0);
    var badge = document.getElementById('tmt-cart-badge');
    badge.textContent = totalQty;
    badge.classList.toggle('hidden', totalQty === 0);
  }

  // ── 商品詳細モーダル ────────────────────────
  var modalProduct   = null;
  var modalColorIdx  = 0;
  var modalColorImgs = {};
  var modalSize      = '';
  var modalQty       = 1;

  var overlay       = document.getElementById('tmt-detail-overlay');
  var modalImg      = document.getElementById('tmt-modal-img');
  var modalTitle    = document.getElementById('tmt-modal-title');
  var modalPrice    = document.getElementById('tmt-modal-price');
  var modalColorsEl = document.getElementById('tmt-modal-colors');
  var modalSizesEl  = document.getElementById('tmt-modal-sizes');
  var modalQtyEl    = document.getElementById('tmt-modal-qty');
  var sizeError     = document.getElementById('tmt-size-error');
  var addBtn        = document.getElementById('tmt-add-to-cart-btn');

  function openDetail(btn) {
    var colors      = btn.dataset.colors.split('|||').filter(Boolean);
    var sizes       = btn.dataset.sizes.split('|||').filter(Boolean);
    var colorImgRaw = btn.dataset.colorImgs.split('|||').filter(Boolean);
    var variantsRaw = (btn.dataset.variants || '[]')
      .replace(/&quot;/g, '"')
      .replace(/&#39;/g, "'")
      .replace(/&amp;/g, '&');
    var variants = [];
    try { variants = JSON.parse(variantsRaw); } catch(e) { console.error('variants parse error:', variantsRaw); }


    modalColorImgs = {};
    colorImgRaw.forEach(function (entry) {
      var parts = entry.split('::');
      if (parts.length >= 2) modalColorImgs[parts[0]] = parts[1] || '';
    });

    modalProduct = {
      id:       btn.dataset.productId,
      title:    btn.dataset.productTitle,
      price:    btn.dataset.productPrice,
      priceNum: parseInt(btn.dataset.productPriceNum, 10),
      img:      btn.dataset.productImg,
      colors:   colors,
      sizes:    sizes,
      variants: variants
    };
    modalColorIdx = 0;
    modalSize     = '';
    modalQty      = 1;

    modalTitle.textContent = modalProduct.title;
    modalPrice.textContent = modalProduct.price;
    modalQtyEl.textContent = '1';
    sizeError.classList.remove('show');
    addBtn.textContent = 'カートに追加';
    addBtn.classList.remove('added');
    addBtn.disabled = false;

    renderModalColors();
    renderModalSizes();
    updateModalImg();
    overlay.classList.add('is-open');
  }

  function closeDetail() { overlay.classList.remove('is-open'); }
  overlay.addEventListener('click', function (e) { if (e.target === overlay) closeDetail(); });
  document.getElementById('tmt-modal-close').addEventListener('click', closeDetail);

  function renderModalColors() {
    modalColorsEl.innerHTML = '';
    modalProduct.colors.forEach(function (c, idx) {
      var btn = document.createElement('button');
      btn.className = 'tmt-modal__color-btn' + (idx === modalColorIdx ? ' is-active' : '');
      btn.textContent = c;
      btn.addEventListener('click', function () {
        modalColorIdx = idx;
        renderModalColors();
        updateModalImg();
      });
      modalColorsEl.appendChild(btn);
    });
  }

  function renderModalSizes() {
    modalSizesEl.innerHTML = '';
    modalProduct.sizes.forEach(function (s) {
      var btn = document.createElement('button');
      btn.className = 'tmt-modal__size-btn' + (s === modalSize ? ' is-active' : '');
      btn.textContent = s;
      btn.addEventListener('click', function () {
        modalSize = s;
        renderModalSizes();
        sizeError.classList.remove('show');
      });
      modalSizesEl.appendChild(btn);
    });
  }

  function updateModalImg() {
    var colorName = modalProduct.colors[modalColorIdx];
    var url = modalColorImgs[colorName] || modalProduct.img;
    modalImg.style.opacity = '0';
    setTimeout(function () { modalImg.src = url; modalImg.style.opacity = '1'; }, 150);
  }

  document.getElementById('tmt-qty-minus').addEventListener('click', function () {
    modalQty = Math.max(1, modalQty - 1);
    modalQtyEl.textContent = modalQty;
  });
  document.getElementById('tmt-qty-plus').addEventListener('click', function () {
    modalQty++;
    modalQtyEl.textContent = modalQty;
  });

  addBtn.addEventListener('click', function () {
    if (!modalSize) { sizeError.classList.add('show'); return; }

    var colorName = modalProduct.colors[modalColorIdx];

    var matchedVariant = (modalProduct.variants || []).find(function(v) {
      return v.color === colorName && v.size === modalSize;
    });
    var variantId = matchedVariant ? 'gid://shopify/ProductVariant/' + matchedVariant.id : null;

    var existing = cart.find(function (item) {
      return item.id === modalProduct.id &&
             item.color === colorName &&
             item.size === modalSize;
    });
    if (existing) {
      existing.qty += modalQty;
    } else {
      cart.push({
        id:        modalProduct.id,
        name:      modalProduct.title,
        price:     modalProduct.price,
        priceNum:  modalProduct.priceNum,
        color:     colorName,
        size:      modalSize,
        qty:       modalQty,
        variantId: variantId
      });
    }

    updateCartBadge();

    addBtn.textContent = '✓ 追加しました';
    addBtn.classList.add('added');
    addBtn.disabled = true;
    setTimeout(function () {
      addBtn.textContent = 'カートに追加';
      addBtn.classList.remove('added');
      addBtn.disabled = false;
      modalQty = 1;
      modalQtyEl.textContent = '1';
    }, 1200);
  });

  document.getElementById('tmt-view-cart-btn').addEventListener('click', function () {
    closeDetail();
    openCart();
  });

  document.querySelectorAll('.tmt-catalog__select-btn').forEach(function (btn) {
    btn.addEventListener('click', function () { openDetail(this); });
  });

  // ── サイドカート ────────────────────────────
  function openCart() {
    renderCartItems();
    document.getElementById('tmt-cart-overlay').classList.add('is-open');
    document.getElementById('tmt-side-cart').classList.add('is-open');
  }
  function closeCart() {
    document.getElementById('tmt-cart-overlay').classList.remove('is-open');
    document.getElementById('tmt-side-cart').classList.remove('is-open');
  }

  document.getElementById('tmt-cart-btn').addEventListener('click', openCart);
  document.getElementById('tmt-cart-close').addEventListener('click', closeCart);
  document.getElementById('tmt-cart-overlay').addEventListener('click', closeCart);

  function renderCartItems() {
    var el           = document.getElementById('tmt-cart-items');
    var submitBtn    = document.getElementById('tmt-submit-order-btn');
    var totalPriceEl = document.getElementById('tmt-cart-total-price');

    if (cart.length === 0) {
      el.innerHTML = '<div class="tmt-cart-empty">カートに商品がありません</div>';
      submitBtn.disabled = true;
      totalPriceEl.textContent = '¥0';
      return;
    }
    submitBtn.disabled = false;
    el.innerHTML = '';

    cart.forEach(function (item) {
      var key = item.id + '::' + item.color + '::' + item.size;
      var div = document.createElement('div');
      div.className = 'tmt-cart-item';
      div.innerHTML =
        '<div class="tmt-cart-item__name">' + item.name + '</div>' +
        '<div class="tmt-cart-item__meta">' + item.color + ' / ' + item.size + '</div>' +
        '<div class="tmt-cart-item__row">' +
          '<button class="tmt-cart-item__qty-btn" data-key="' + key + '" data-delta="-1">−</button>' +
          '<span class="tmt-cart-item__qty-num">' + item.qty + '</span>' +
          '<button class="tmt-cart-item__qty-btn" data-key="' + key + '" data-delta="1">＋</button>' +
          '<button class="tmt-cart-item__delete" data-key="' + key + '">✕</button>' +
        '</div>';
      el.appendChild(div);
    });

    el.querySelectorAll('.tmt-cart-item__qty-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var key   = this.dataset.key;
        var delta = parseInt(this.dataset.delta);
        cart = cart.map(function (item) {
          if (item.id + '::' + item.color + '::' + item.size === key) {
            item.qty = Math.max(1, item.qty + delta);
          }
          return item;
        });
        updateCartBadge();
        renderCartItems();
      });
    });

    el.querySelectorAll('.tmt-cart-item__delete').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var key = this.dataset.key;
        cart = cart.filter(function (item) {
          return item.id + '::' + item.color + '::' + item.size !== key;
        });
        updateCartBadge();
        renderCartItems();
      });
    });

    var totalAmount = cart.reduce(function (s, i) { return s + i.priceNum * i.qty; }, 0);
    totalPriceEl.textContent = '¥' + totalAmount.toLocaleString('ja-JP') + '（税込）';
  }

  // ── 注文確認モーダル ────────────────────────
  var confirmOverlay = document.getElementById('tmt-confirm-overlay');

function openConfirm() {
  closeCart();
  var el = document.getElementById('tmt-confirm-items');
  el.innerHTML = '';
  cart.forEach(function (item) {
    var row = document.createElement('div');
    row.className = 'tmt-confirm-item-row';
    row.innerHTML =
      '<span>' + item.name + '</span>' +
      '<span class="tmt-confirm-item-meta">' + item.color + ' / ' + item.size + ' × ' + item.qty + '</span>';
    el.appendChild(row);
  });
  document.getElementById('tmt-confirm-content').style.display = '';
  document.getElementById('tmt-success-msg').classList.remove('show');
  document.getElementById('tmt-form-error').classList.remove('show');
  ['tmt-f-company','tmt-f-name','tmt-f-email','tmt-f-phone',
   'tmt-f-zip','tmt-f-pref','tmt-f-city','tmt-f-address1','tmt-f-notes'].forEach(function (id) {
    document.getElementById(id).value = '';
  });
  confirmOverlay.classList.add('is-open');
}

  function closeConfirm() { confirmOverlay.classList.remove('is-open'); }

  document.getElementById('tmt-submit-order-btn').addEventListener('click', openConfirm);
  document.getElementById('tmt-confirm-close').addEventListener('click', closeConfirm);
  confirmOverlay.addEventListener('click', function (e) { if (e.target === confirmOverlay) closeConfirm(); });

document.getElementById('tmt-confirm-submit-btn').addEventListener('click', function () {
  var company  = document.getElementById('tmt-f-company').value.trim();
  var name     = document.getElementById('tmt-f-name').value.trim();
  var email    = document.getElementById('tmt-f-email').value.trim();
  var phone    = document.getElementById('tmt-f-phone').value.trim();
  var zip      = document.getElementById('tmt-f-zip').value.trim();
  var pref     = document.getElementById('tmt-f-pref').value.trim();
  var city     = document.getElementById('tmt-f-city').value.trim();
  var address1 = document.getElementById('tmt-f-address1').value.trim();
  var notes    = document.getElementById('tmt-f-notes').value.trim();
  var errEl    = document.getElementById('tmt-form-error');

  if (!company || !name || !email || !phone || !zip || !pref || !city || !address1) {
    errEl.textContent = '必須項目を入力してください';
    errEl.classList.add('show');
    return;
  }
  if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
    errEl.textContent = '有効なメールアドレスを入力してください';
    errEl.classList.add('show');
    return;
  }

  var btn = document.getElementById('tmt-confirm-submit-btn');
  btn.disabled = true;
  btn.textContent = '送信中...';

  fetch('https://tmt-draft-order2.vercel.app/api/draft-order', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      company:  company,
      name:     name,
      email:    email,
      phone:    phone,
      zip:      zip,
      pref:     pref,
      city:     city,
      address1: address1,
      notes:    notes,
      items:    cart
    })
  })
  .then(function(res) {
    if (!res.ok) throw new Error('server error');
    return res.json();
  })
  .then(function() {
    document.getElementById('tmt-confirm-content').style.display = 'none';
    document.getElementById('tmt-success-msg').classList.add('show');
    cart = [];
    updateCartBadge();
    btn.disabled = false;
    btn.textContent = '注文を送信する';
  })
  .catch(function() {
    errEl.textContent = 'エラーが発生しました。もう一度お試しください。';
    errEl.classList.add('show');
    btn.disabled = false;
    btn.textContent = '注文を送信する';
  });
});

})();
